import axios from "axios";
import config from "src/config";
import { convertRedirectUrl } from "./SitesApi/convertRedirectUrl";

export function createApi(baseURL = config.API_URL) {
  const instance = axios.create({ baseURL });

  instance.defaults.headers.common["Content-Type"] = "application/json";
  instance.defaults.headers.post["Content-Type"] = "application/json";
  instance.defaults.headers.patch["Content-Type"] = "application/json";
  instance.defaults.headers.put["Content-Type"] = "application/json";
  instance.defaults.headers.delete["Content-Type"] = "application/json";

  return {
    async auth({ email, password, redirect_url: redirectUrl }) {
      try {
        if (typeof redirectUrl !== "string" || !redirectUrl) {
          redirectUrl = "https://base.curaytor.com/";
        }

        const response = await instance.post(
          "auth",
          JSON.stringify({ email, password, redirect_url: redirectUrl })
        );

        const data = response.data.data;

        let finalRedirectUrl = data.redirect_url;
        finalRedirectUrl = convertRedirectUrl(data.code, data.redirect_url);

        return finalRedirectUrl;
      } catch (err) {
        throw err;
      }
    },
    async googleAuth({ code, redirect_url }) {
      try {
        const response = await instance.post(
          "auth/google_sign_in",
          JSON.stringify({ code, redirect_url })
        );
        window.location.href = response.data.data.redirect_url;
        return response;
      } catch (err) {
        throw err;
      }
    },
    async resetPasswordRequest({ email }) {
      try {
        return instance.post(
          "auth/reset_password_request",
          JSON.stringify({ email })
        );
      } catch (err) {
        throw err;
      }
    },
    async passwordChangeTokenVerify({ email, token }) {
      try {
        return instance.post(
          "auth/password_change_token_verify",
          JSON.stringify({ email, token })
        );
      } catch (err) {
        throw err;
      }
    },
    async passwordChange({ email, token, password, password_repeated }) {
      try {
        return instance.post(
          "auth/password_change",
          JSON.stringify({ email, token, password, password_repeated })
        );
      } catch (err) {
        throw err;
      }
    }
  };
}

export default createApi();



// WEBPACK FOOTER //
// ./src/services/api.js